<template>
  <div class="no-more">没有更多了</div>
</template>

<style lang="scss" scoped>
.no-more {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  color: var(--color-gray-500);
  font-size: 14px;
}
</style>
